import { createSelector } from '@reduxjs/toolkit';
import { fetchCategoryRelatedSearchesByCatID } from '@/redux/api/categoryRelatedSearches';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_CATEGORY_RELATED_SEARCHES_FAIL = 'la/domain/items/LOAD_CATEGORY_RELATED_SEARCHES_FAIL';
export const LOAD_CATEGORY_RELATED_SEARCHES_SUCCESS = 'la/domain/items/LOAD_CATEGORY_RELATED_SEARCHES_SUCCESS';

interface DefaultState {
    categoryRelatedSearches: {
        displayName: string;
        imageUrl: string;
        relatedCategoryId: number;
        url: string;
    }[];
}

/* reducer */
export const DEFAULT_STATE: DefaultState = {
    categoryRelatedSearches: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_CATEGORY_RELATED_SEARCHES_FAIL:
            return {
                ...state,
                categoryRelatedSearches: [],
            };
        case LOAD_CATEGORY_RELATED_SEARCHES_SUCCESS:
            return {
                ...state,
                categoryRelatedSearches: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.categoryRelatedSearches;

export const getCategoryRelatedSearches = createSelector(stateSelector, (state) => state.categoryRelatedSearches || []);

/* ACTION CREATORS */
export const fetchCategoryRelatedSearches = (categoryId: string) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);
    try {
        const response = await fetchCategoryRelatedSearchesByCatID({ authToken, categoryId, deployment });

        dispatch({
            payload: response.payload,
            type: LOAD_CATEGORY_RELATED_SEARCHES_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { categoryId },
            payload: error,
            type: LOAD_CATEGORY_RELATED_SEARCHES_FAIL,
        });
    }
};
